define.alias("shared/components/shared/publish/switcher/item/business-button", "calendar/components/shared/publish/switcher/item/business-button");